import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "select"]
  static values = { config: Object }

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasSourceTarget || !this.hasSelectTarget) return

    const config = this.configValue[this.sourceTarget.value]
    if (!config) return

    const currentValue = this.selectTarget.value
    const allowedValues = config.options.map((option) => option.value)
    const nextValue = allowedValues.includes(currentValue) ? currentValue : config.defaultValue

    this.selectTarget.innerHTML = ""

    config.options.forEach((option) => {
      const optionElement = document.createElement("option")
      optionElement.value = option.value
      optionElement.textContent = option.label
      optionElement.selected = option.value === nextValue
      this.selectTarget.appendChild(optionElement)
    })

    this.selectTarget.value = nextValue
    if (nextValue === currentValue) return

    this.selectTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
